import axios, { buildApi } from '@/libs/api.request';
let name = '/shipments/loop'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/confirm',name+'/delete&del']
})